// Copyright (c) 2017 Deere & Company

import * as SearchHelper from '../../search/services/helpers';
import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import {routerActions} from 'react-router-redux';
import {translate} from '../../../shared/services/translation-service';

export const onSearch = (searchBy, query) =>
    dispatch => {

        if (SearchHelper.isQueryStringValid(query, searchBy)) {

            dispatch(routerActions.push(`/part-requests/search?by=${searchBy}&q=${encodeURIComponent(query)}`));

        } else {

            const translatedErrorMessage = translate(SearchHelper.getSearchErrorMessageId(searchBy));

            errorAlertBar(createErrorObject(translatedErrorMessage));

        }

    };



// WEBPACK FOOTER //
// ./src/part-requests/shared/action-creators/search.js